<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">
        <div class="row">
          <div class="form-group col-4">
            <app-lfsa-input [control]="this.agregarForm.get('id')" [id]="'id'" [label]="'Cod. Motivo'"
                            formControlName="id"
                            type="number"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('id')?.hasError('pattern')"
                   class="letrasDanger">*Solo
              números y punto, hasta 4 decimales. Ej: 12.3456</small>
          </div>
          <div class="form-group col-8">
            <app-lfsa-input [control]="this.agregarForm.get('descripcion')" [id]="'descripcion'" [label]="'Descripción'"
                            formControlName="descripcion"
                            type="text"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('descripcion')?.hasError('required')"
                   class="letrasDanger">
              *El campo Descripción es requerido</small>
          </div>

          <div class="form-group col-12 mb-3">
            <label for="">Estado</label>
            <select class="form-control" formControlName="estado" id="estado">
              <!-- (change)="onChangeValues();onChangeestado()" -->
              <option value="0">Activo</option>
              <option value="1">Inactivo</option>
            </select>
            <div *ngIf="agregarForm.controls['estado'].invalid" class="text-danger mt-3">
              <small>
                <div *ngIf="agregarForm.controls['estado'].errors">
                  *El campo estado es requerido.
                </div>
              </small>
            </div>
          </div>


          <div class="col-12">
            Aplica solo para planificacion (activo), o Solo para balanza (desactivado):
            <div class="p-3" style="border: 1px solid rgb(69, 69, 151); border-radius: 5px;">
              <div class="form-group col-12 d-flex mb-2">
                <label class="pr-3" for="enPlanificacion" style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">Motivo de Planificación
                  <input formControlName="enPlanificacion" id="enPlanificacion" type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center" style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('enPlanificacion').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('enPlanificacion').value">No</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            Tipo de Orden:
            <div class="p-3" style="border: 1px solid rgb(69, 69, 151); border-radius: 5px;">
              <div class="form-group col-12 d-flex mb-2">
                <label class="pr-3" for="compra"
                       style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">
                  Compra
                  <input (change)="onChangeTipoOrden();" formControlName="compra" id="compra" type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center"
                     style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('compra').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('compra').value">No</span>
                </div>
              </div>
              <div class="form-group col-12 d-flex mb-2">
                <label class="pr-3" for="venta"
                       style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">
                  Venta
                  <input (change)="onChangeTipoOrden();" formControlName="venta" id="venta" type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center"
                     style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('venta').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('venta').value">No</span>
                </div>
              </div>
              <div class="form-group col-12 d-flex mb-2">
                <label class="pr-3" for="traslado"
                       style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">
                  Traslado
                  <input (change)="onChangeTipoOrden();" formControlName="traslado" id="traslado" type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center"
                     style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('traslado').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('traslado').value">No</span>
                </div>
              </div>
              <div class="form-group col-12 d-flex mb-2">
                <label class="pr-3" for="informativo"
                       style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">
                  Informativo
                  <input (change)="onChangeTipoOrden();" formControlName="informativo" id="informativo"
                         type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center"
                     style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('informativo').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('informativo').value">No</span>
                </div>
              </div>
              <div class="form-group col-12 d-flex">
                <label class="pr-3" for="maquila"
                       style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">
                  Maquila
                  <input (change)="onChangeTipoOrden();" formControlName="maquila" id="maquila" type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center"
                     style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('maquila').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('maquila').value">No</span>
                </div>
              </div>
            </div>
            <div *ngIf="!tipoOrdenSeleccionado" class="text-danger mt-3">
              <small>
                <div>
                  *Debe seleccionar al menos un Tipo de Orden.
                </div>
              </small>
            </div>
          </div>


          <div class="col-12">
            Activo para:
            <div class="p-3" style="border: 1px solid rgb(69, 69, 151); border-radius: 5px;">
              <div class="form-group col-12 d-flex mb-2">
                <label class="pr-3" for="difCalidad"
                       style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">
                  Dif. Calidad
                  <input (change)="onChangeActivoPara()" formControlName="difCalidad" id="difCalidad" type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center"
                     style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('difCalidad').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('difCalidad').value">No</span>
                </div>
              </div>
              <div class="form-group col-12 d-flex mb-2">
                <label class="pr-3" for="difPesos"
                       style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">
                  Dif. Pesos
                  <input (change)="onChangeActivoPara()" formControlName="difPesos" id="difPesos" type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center"
                     style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('difPesos').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('difPesos').value">No</span>
                </div>
              </div>
              <div class="form-group col-12 d-flex">
                <label class="pr-3" for="anulacion"
                       style="width: 150px;display: flex; justify-content: space-between;margin-right: 15px;">
                  Anulación O/B
                  <input (change)="onChangeActivoPara()" formControlName="anulacion" id="anulacion" type="checkbox"/>
                </label>
                <div class="pl-3 d-flex justify-content-center"
                     style="width: 150px;background: rgba(106, 106, 106, 0.319);">
                  <span *ngIf="this.agregarForm.get('anulacion').value">Si</span>
                  <span *ngIf="!this.agregarForm.get('anulacion').value">No</span>
                </div>
              </div>
            </div>
            <div *ngIf="!activoParaSeleccionado" class="text-danger mt-3">
              <small>
                <div>
                  *Debe seleccionar al menos un Activo para.
                </div>
              </small>
            </div>
          </div>


        </div>

        <!-- (ejecutarEvento)="getCuentasContables()" -->
        <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarForm.invalid"
                                     [loading]="loading" [textBoton]="'Guardar'"
                                     class="row mt-3">
        </app-lfsa-botones-formulario>
      </div>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
